import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	CircularProgress,
	Box,
	Backdrop,
	IconButton,
	Tooltip,
} from '@material-ui/core';
//icons
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import CallMadeIcon from '@material-ui/icons/CallMade';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import EditIcon from '@material-ui/icons/Edit';

//services/utils
import {CurrencyFormat} from '../../util/currencyFormat';
import {DateFormat} from '../../util/DateFormat';
import _ from 'lodash';
import {openLink} from '../../services/navigationService';

const WalletTransactionDialog = (
	{
		isShowWalletTransactionModal,
		handleCloseWalletTransactionModal,
		walletTransactions,
		isRequesting,
		customerToViewWallet,
		nextOffset,
		handleLoadMoreTransactions,
		isWalletRequesting,
		walletInfo,
		handleOpenUpdateTransaction
	}
) => {
	return (
		<Dialog
			open={!!isShowWalletTransactionModal}
			onClose={handleCloseWalletTransactionModal}
			fullWidth
			maxWidth="md"
		>
			<DialogTitle disableTypography>
				<Box mb={1}>
					<Typography variant="h6" display="flex" alignItems="center" gutterBottom>
						<AccountBalanceWalletIcon
							fontSize="medium"
							style={{marginRight: 8, color: '#3f51b5'}}
						/>
						Wallet Historic of customer:&nbsp;
						{customerToViewWallet?.is_deleted ? (
							<span style={{color: 'red'}}>Deleted Account</span>
						) : (
							customerToViewWallet?.name || 'N/A'
						)}
					</Typography>
					<Typography variant="subtitle1" style={{color: "#388e3c", fontWeight: 'bold'}}>
						(
						{walletInfo
							? CurrencyFormat(walletInfo.balance)
							: CurrencyFormat(0)}
						)
					</Typography>
				</Box>
			</DialogTitle>

			<DialogContent dividers style={{position: 'relative'}}>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell>Admin</TableCell>
							<TableCell>OrderId</TableCell>
							<TableCell>Reason</TableCell>
							<TableCell>Comment</TableCell>
							<TableCell>Creation Date/Time</TableCell>
							<TableCell align="right">Amount</TableCell>
							<TableCell align="center">Actions</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{walletTransactions?.length > 0 ? (
							walletTransactions.map((item, index) => (
								<TableRow key={index}>
									<TableCell>{item.admin_info}</TableCell>
									<TableCell
										onClick={item.order_number ? () => openLink({url: `/admin/order/details/${item.order_number}`}) : undefined}
										style={{cursor: item.order_number ? 'pointer' : 'default'}}
									>
										<Box display="flex" alignItems="center" gap={1}>
											<Typography
												color={item.order_number ? 'primary' : 'textSecondary'}
												sx={{
													textDecoration: item.order_number ? 'underline' : 'none',
												}}
											>
												{item.order_number}
											</Typography>
										</Box>
									</TableCell>
									<TableCell>{_.capitalize(item.reason)}</TableCell>
									<TableCell>{_.capitalize(item.comment)}</TableCell>
									<TableCell>{DateFormat(item.createdAt)}</TableCell>
									<TableCell align="right" style={{fontWeight: 'bold'}}>
                                        <span
	                                        style={{
		                                        display: 'inline-flex',
		                                        alignItems: 'center',
		                                        color: item.transaction_type === 'debit' ? '#d32f2f' : '#388e3c',
	                                        }}
                                        >
                                            {item.transaction_type === 'debit' ? (
	                                            <CallMadeIcon fontSize="small" style={{marginRight: 4}}/>
                                            ) : (
	                                            <CallReceivedIcon fontSize="small" style={{marginRight: 4}}/>
                                            )}
	                                        {item.transaction_type === 'debit' ? '-' : '+'}
	                                        {CurrencyFormat(item.wallet_amount)}
                                        </span>
									</TableCell>
									<TableCell align="center">
										{handleOpenUpdateTransaction && (
											<Tooltip title="Edit Order Number" arrow>
												<IconButton
													size="small"
													color="primary"
													onClick={() => handleOpenUpdateTransaction(item)}
												>
													<EditIcon fontSize="small"/>
												</IconButton>
											</Tooltip>
										)}
									</TableCell>
								</TableRow>
							))
						) : !isRequesting ? (
							<TableRow>
								<TableCell colSpan={7} align="center">
									No data
								</TableCell>
							</TableRow>
						) : null}
					</TableBody>
				</Table>

				{nextOffset !== null && (
					<Box textAlign="center" mt={2}>
						<Button
							variant="outlined"
							onClick={handleLoadMoreTransactions}
							disabled={isWalletRequesting}
						>
							{isWalletRequesting ? 'Loading...' : 'Load More'}
						</Button>
					</Box>
				)}

				{/* Fullscreen or local overlay loading spinner */}
				{isWalletRequesting && (
					<Backdrop
						open
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							zIndex: 1,
							backgroundColor: 'rgba(255, 255, 255, 0.7)',
						}}
					>
						<CircularProgress/>
					</Backdrop>
				)}
			</DialogContent>

			<DialogActions>
				<Button onClick={handleCloseWalletTransactionModal} color="secondary">
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default WalletTransactionDialog;
